<template>
<div>
    <v-card>
        <v-card-title class="align-baseline">
            <v-btn color="error" @click="initIncrement = true" :disabled="!toggleIncrementBtn">increment grade levels</v-btn>
            <v-switch v-model="toggleIncrementBtn"></v-switch>
            <v-spacer></v-spacer>
            <v-flex xs4>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-flex>
        </v-card-title>
        <v-data-table :headers="headers" :items="students" :search="search" :rows-per-page-items="[50,100,200]">
            <template slot="items" slot-scope="props">
                <tr>
                    <td class="text-xs-left">{{ props.item.id }}</td>
                    <td class="text-xs-left">{{ props.item.first_name }}</td>
                    <td class="text-xs-left">{{ props.item.last_name }}</td>
                    <td class="text-xs-left">{{ props.item.grade }}</td>
                    <td class="text-xs-left">
                        {{ props.item.parent.first_name }} {{ props.item.parent.last_name }}
                    </td>
                    <td class="text-xs-center">
                        <v-tooltip bottom>
                            <v-btn slot="activator" icon class="mx-0" @click="editStudent(props.item)">
                                <v-icon color="teal">create</v-icon>
                            </v-btn>
                            <span>Edit student details</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <v-btn slot="activator" icon class="mx-0" @click="manageClasses(props.item)">
                                <v-icon color="primary">library_books</v-icon>
                            </v-btn>
                            <span>Manage student's classes</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <v-btn slot="activator" icon class="mx-0" @click="initDeleteStudent(props.item)">
                                <v-icon color="error">delete_forever</v-icon>
                            </v-btn>
                            <span>Delete student</span>
                        </v-tooltip>
                    </td>
                </tr>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
    </v-card>

    <v-dialog persistent v-model="editStudentDialog" max-width="500px">
        <student-edit-form :active="editStudentDialog" :studentData="studentData" @close="editStudentDialog = false">
        </student-edit-form>
    </v-dialog>

    <v-dialog persistent v-model="deleteStudentDialog" max-width="700px">
        <v-card>
            <v-card-text>
                <v-alert :value="true" type="error">
                    Are you sure you want to delete {{ studentData.first_name }} {{ studentData.last_name }}?
                </v-alert>
            </v-card-text>
            <v-card-actions class="mr-2 pb-3">
                <v-spacer></v-spacer>
                <v-btn small color="primary" @click="deleteStudentDialog = false">No</v-btn>
                <v-btn small color="primary" @click="deleteStudent">Yes</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="alert.active" max-width="700px">
        <v-card>
            <v-card-text>
                <v-alert :value="true" :type="alert.type">{{ alert.message }}</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn flat color="primary" @click="alert.active = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="initIncrement" max-width="500px">
        <increment-grade-levels-dialog @close="initIncrement = false; toggleIncrementBtn = false;">
        </increment-grade-levels-dialog>
    </v-dialog>

</div>
</template>

<script>
import EditForm from './EditForm'
import IncrementGradeLevelsDialog from './IncrementGradeLevelsDialog'

export default {
    components: {
        StudentEditForm: EditForm,
        IncrementGradeLevelsDialog
    },
    data() {
        return {
            toggleIncrementBtn: false,
            initIncrement: false,
            search: '',
            headers: [{
                    text: 'ID',
                    align: 'left',
                    value: 'id',
                    width: '5%'
                },
                {
                    text: 'First name',
                    align: 'left',
                    value: 'first_name',
                    width: '20%'
                },
                {
                    text: 'Last name',
                    align: 'left',
                    value: 'last_name',
                    width: '20%'
                },
                {
                    text: 'Grade',
                    align: 'left',
                    value: 'grade',
                    width: '5%'
                },
                {
                    text: 'Parent',
                    align: 'left',
                    value: '',
                    width: '25%'
                },
                {
                    text: 'Actions',
                    align: 'center',
                    value: '',
                    width: '25%'
                },
            ],
            studentData: {},
            editStudentDialog: false,
            deleteStudentDialog: false,
            alert: {
                active: false,
                message: '',
                type: 'success'
            }
        }
    },
    computed: {
        students() {
            return this.$store.state.admin.students
        },
    },
    methods: {
        editStudent(student) {
            this.studentData = Object.assign({}, student)
            this.editStudentDialog = true
        },
        manageClasses(student) {
            this.$store.commit('setEnrollmentStudent', student)
            this.$router.push('/enrollment')
            // future refactor - try and pass params to enrollment route, e.g. /enrollment?id=4, but make sure route it protected
            // this.$store.dispatch('getStudentSchedule', student.id).then(() => this.$router.push('/enrollment'))
        },
        initDeleteStudent(student) {
            this.deleteStudentDialog = true
            this.studentData = Object.assign({}, student)
        },
        deleteStudent() {
            this.deleteStudentDialog = false
            this.$store.dispatch('deleteStudent', this.studentData.id).then(() => {
                    this.alert.active = true
                    this.alert.message = `${this.studentData.first_name} ${this.studentData.last_name} has successfully been deleted.`
                    this.alert.type = 'success'
                })
                .catch((e) => {
                    this.alert.active = true
                    this.alert.type = 'error'

                    if (e.response.status === 400) {
                        this.alert.message = `${this.studentData.first_name} ${this.studentData.last_name} is still enrolled or waitlisted in at least one course. You must remove them from all classes before deleting them.`
                    } else {
                        this.alert.message = 'Whoops looks like something went wrong!!(in DataTable.vue)'
                    }
                })
        }
    }
}
</script>
